import DialogExpired from './DialogExpired';

export default DialogExpired;
